var React = require("../../../js/libs/react/react-polyfill");

module.exports = React.createClass({
  
  displayName: "EmptyForm",
  
  render: function() {
    return React.DOM.div({});
  }
  
});
